import { render, staticRenderFns } from "./updateNotice.vue?vue&type=template&id=99e7a632&scoped=true"
import script from "./updateNotice.vue?vue&type=script&lang=js"
export * from "./updateNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e7a632",
  null
  
)

export default component.exports